<template>
  <div class="gateway-container">
    <!-- 初始对话框 -->
    <el-dialog
        v-model="dialogVisible"
        :close-on-click-modal="false"
        :show-close="false"
        width="25vw"
        class="gateway-dialog"
    >
      <span>
      Please enter your UMLS API key to access this application.
  <br/>
You can obtain an API key from the UMLS website.
    </span>
      <br/>
      <br/>


      <template #header>
        <div class="gateway-header">
          <el-icon size="24"><Key /></el-icon>
          <span>UMLS API Key Verification</span>
        </div>
      </template>
      <strong style="stroke: #202124">API key</strong> <br/>
      <el-input
          v-model="apiKey"
          placeholder="Please enter UTS API Key"
          clearable
          prefix-icon="Lock"
          class="gateway-input"
          size="default"
          style="width: 65%; border: 1px solid #202124; border-radius: 12px; margin-bottom: 12px"
      />
      <br/>
      <el-button style="left: auto; right: auto" @click="checkKey" type="primary" :loading="loading" size="large" round>
        Validate
      </el-button>

      <template #footer>
        <p style="font-size: 12px">Don't have an API key? Get one <a href="https://uts.nlm.nih.gov/uts/profile">here</a>.</p>
      </template>
    </el-dialog>

    <!-- 验证成功后才渲染主应用 -->
    <App v-if="verified" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import App from "../App.vue";
import axios from "axios";
import { ElMessage } from "element-plus";
import { Key } from "@element-plus/icons-vue";

const apiKey = ref("");
const dialogVisible = ref(true);
const verified = ref(false);
const loading = ref(false);

import { onMounted } from "vue";

onMounted(() => {
  const savedKey = localStorage.getItem("uts_api_key");

  if (savedKey) {
    apiKey.value = savedKey;
    verified.value = true;
    dialogVisible.value = false;
  }
});


async function checkKey() {
  if (!apiKey.value) {
    ElMessage.error("Empty API Key is not allowed here");
    return;
  }
  loading.value = true;

  try {
    const res = await axios.get("https://uts-ws.nlm.nih.gov/rest/content/current/source/SNOMEDCT_US/9468002", {
      params: { apiKey: apiKey.value }
    });

    if (res.data.name !== 'UnauthorizedError') {
      ElMessage.success("Identification Succeed!");
      localStorage.setItem("uts_api_key", apiKey.value); // 存储 key
      verified.value = true;
      dialogVisible.value = false;
    } else {
      ElMessage.error("Invalid API Key");
    }
  } catch (e) {
    ElMessage.error("Invalid API Key. Please check your network connection or your api key.");
  } finally {
    loading.value = false;
  }
}

</script>


<style scoped>

/* Dialog 美化 */
.gateway-dialog {
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
}


.gateway-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 18px;
  color: #333;
}


.gateway-input :deep(.el-input__wrapper) {
  border-radius: 10px;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.05);
}


.el-button.is-round {
  padding: 12px 30px;
  font-weight: 600;
}

:deep(.el-dialog__footer) {
  display: flex;
  justify-content: center; /* 居中对齐 */
}
</style>
